module.exports = __webpack_public_path__ + "assets/img/img-3.521cc5b7.png";